module.exports = __webpack_public_path__ + "img/qbfilter.9ccaf86d.svg";